import { render, staticRenderFns } from "./ProductReviewsComponent.vue?vue&type=template&id=270a3c04&"
import script from "./ProductReviewsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports